import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import HttpApi from 'i18next-http-backend';
import namespaces from './i18nNamespaces.json';
i18n
  .use(initReactI18next)
  .use(HttpApi)
  .init({
    lng: 'de',
    fallbackLng: 'de',
    ns: namespaces,
    interpolation: {
      escapeValue: false,
    },
    backend: {
      loadPath: `${process.env.REACT_APP_ORDER_URL}/locales/{{lng}}/{{ns}}.json?v=${window['VERSION']}`,
      crossDomain: true,
    },
    react: {
      useSuspense: true,
    },
    partialBundledLanguages: true,
  });

export default i18n;
